import { AxiosError } from 'axios';
import { useState } from 'react';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useResetPassword = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);

  const onResetPasswordError = (err: AxiosError<ErrorHttpResponse>) => {
    console.error(
      err?.response?.data?.message ?? 'Something went wrong while resetting the password.',
    );
  };

  const onResetPasswordSuccess = (callbackFn: () => void) => ({
    data,
    message,
  }: SuccessHttpResponse<any>) => {
    callbackFn();
  };

  const resetPassword = (data: any, callbackFn?: () => void) => {
    const url: HttpConfig = {
      url: 'api/v1/auth/reset-password',
      method: 'post',
      data: data
    };

    request(url, onResetPasswordSuccess(callbackFn ?? (() => {})), setLoading, onResetPasswordError);
  };

  return { resetPassword, loading };
};

export default useResetPassword;
